// VicTech #710:向伺服器取「当前 agent 可见、open、带 need-human」的对话 id 清单。
// 走既有 GET /api/v1/accounts/:id/conversations(伺服器端已按该 agent 的收件箱权限过滤)。
import ConversationApi from 'dashboard/api/inbox/conversation';
import { NEED_HUMAN_LABEL } from './constants';
import { isNeedHuman } from './tracker';

const PER_PAGE = 25;
const MAX_PAGES = 10;

export const fetchNeedHumanIds = async (api = ConversationApi) => {
  const ids = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    // eslint-disable-next-line no-await-in-loop
    const { data } = await api.get({
      status: 'open',
      assigneeType: 'all',
      labels: [NEED_HUMAN_LABEL],
      page,
    });
    const payload = data?.data?.payload || [];
    payload.filter(isNeedHuman).forEach(c => ids.push(c.id));
    if (payload.length < PER_PAGE) break;
  }
  return ids;
};
